import { useRef } from "react";

import Flicking from "@egjs/react-flicking";
import { useHistory } from "react-router-dom";

import { AccountOnHold, AccountOnHoldCheckoutMessage } from "@/components/AccountOnHold";
import Box from "@/components/Box";
import { CollapseableText } from "@/components/CollapseableText";
import {
  dashboardMainStackMaxWidth,
  dashboardShopListSubtitleFontSize,
  dashboardShopListSubtitleControlsGap,
  dashboardShopListSwitcherTitleGap,
  dashboardShopListTitleFontSize,
  dashboardShopListTitleSubtitleGap
} from "@/components/organisations/learningHub/dashboardLayout";
import ShopPageFiltersLayout from "@/components/organisations/shop/ShopPageFiltersLayout";
import { theme } from "@/core/theme";
import useWindowSize from "@/hooks/use-window-size";
import { PanelBoxV2 } from "@/tpo/Boxes";
import Center from "@/tpo/Center";
import SegmentedControl from "@/tpo/SegmentedControl";
import Stack from "@/tpo/Stack";

export default function ListPageTemplate({
  bg,
  header,
  tab,
  title,
  subtitle,
  children,
  urlMap,
  pb,
  switcherOptions = [],
  centerProps = {},
  aboveSwitcher = null,
  filterSidebar = null
}) {
  const history = useHistory();

  const flickingApiRef = useRef();
  const { width } = useWindowSize();
  const align = width < 450 ? "0" : "center";

  const pageContent = (
    <>
      <PanelBoxV2
        maxWidth={760}
        outer={{
          pt: filterSidebar ? 0 : theme.spacing.section.pt,
          px: 0,
          bg
        }}
      >
        <Center {...centerProps}>{aboveSwitcher}</Center>
      </PanelBoxV2>
      <Box
        mx={filterSidebar ? [-28, -28, 0] : 0}
        width={filterSidebar ? ["calc(100% + 56px)", "calc(100% + 56px)", "100%"] : "100%"}
      >
        <Box px={filterSidebar ? [28, 0, 0] : 0}>
          <Flicking align={align} key={width} bound moveType="freeScroll" ref={flickingApiRef}>
            <SegmentedControl
              data={switcherOptions}
              onChange={v => history.push(urlMap[v])}
              value={tab}
              size={["xs", "xs", "sm"]}
              bg={bg === "white" ? "haze" : "white"}
            />
          </Flicking>
        </Box>
      </Box>
      <PanelBoxV2
        maxWidth={760}
        outer={{
          pt: filterSidebar ? dashboardShopListSwitcherTitleGap : 40,
          pb: filterSidebar ? 0 : pb,
          px: filterSidebar ? 0 : [20, 20, 40],
          bg
        }}
        inner={{
          textAlign: "center"
        }}
      >
        <Stack gap={dashboardShopListTitleSubtitleGap}>
          <Box fontFamily="gilroyBold" fontSize={dashboardShopListTitleFontSize}>
            {title}
          </Box>
          <CollapseableText fontSize={dashboardShopListSubtitleFontSize}>
            {subtitle}
          </CollapseableText>
        </Stack>
      </PanelBoxV2>
      {filterSidebar ? (
        <PanelBoxV2
          maxWidth={dashboardMainStackMaxWidth}
          outer={{
            bg,
            pt: dashboardShopListSubtitleControlsGap,
            pb: pb,
            px: 0
          }}
        >
          {children}
        </PanelBoxV2>
      ) : (
        children
      )}
    </>
  );

  return (
    <>
      {header}
      {filterSidebar ? (
        <ShopPageFiltersLayout filterSidebar={filterSidebar}>{pageContent}</ShopPageFiltersLayout>
      ) : (
        pageContent
      )}
    </>
  );
}

ListPageTemplate.defaultProps = {
  pb: theme.spacing.section.pb
};
